import { render, staticRenderFns } from "./InterfaceCheckbox.vue?vue&type=template&id=eda0d6d6"
import script from "./InterfaceCheckbox.vue?vue&type=script&lang=js"
export * from "./InterfaceCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports